// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"c1b97df1","496":"d5687c62","850":"8bcb2e3c"}[chunkId] + ".chunk.js";
};